<template>
    <v-container fluid>
        <v-btn icon @click="exportToCsv">
            <v-icon v-if="!excel" color="green" large> mdi-file-excel </v-icon>
            <v-progress-circular
                v-else
                :size="30"
                color="green"
                indeterminate
            ></v-progress-circular>
        </v-btn>
        <v-btn icon @click="exportToPDF">
            <v-icon v-if="!pdf" color="red" large> mdi-file-pdf-box </v-icon>
            <v-progress-circular
                v-else
                :size="30"
                color="red"
                indeterminate
            ></v-progress-circular>
        </v-btn>
        <v-expansion-panels
            v-model="panel"
        >
            <v-expansion-panel>
                <v-expansion-panel-header class="card-title mt-1">
                    <v-row align="center">
                        <v-col cols="6">
                            Έσοδα
                            <v-icon color="black" class="px-4" @click.stop="togglePanel()">
                                mdi-tune
                            </v-icon>
                        </v-col>
                        <v-col cols="6" align="end">
                            <v-btn class="my-2 mr-2" dark small color="black" @click="createIncome">
                                <v-icon dark>mdi-plus</v-icon>Καταχώριση
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <filters
                        :filters="displayInfo"
                        @reloadFilters="reloadFilters"
                        @filterResults="filterResults"
                    />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <array-view
            :items="incomes"
            :headers="displayInfo.filter(element => element.showArray)"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            :totals="totals"
            @onDelete="onDelete"
            @handleClick="handleClick"
            @paginationChange="paginationChange"
        />
        <div id="export" />
    </v-container>
</template>

<script>
    import incomeService from '@/services/income'
    import ArrayView from '@/components/ArrayView'
    import Filters from '@/components/Filters'
    import categoryService from '@/services/category'
    import chargeUnitService from '@/services/chargeUnit'
    import html2pdf from 'html2pdf.js'

    export default {
        name: 'Income',
        components: { ArrayView, Filters },
        data: () => {
            return {
                successfullImport: null,
                incomes: [],
                displayInfo: [
                    {
                        text: 'Id',
                        value: 'id',
                        showArray: true,
                        disabled: false
                    },
                    {
                        text: 'Ημερομηνία εσόδου',
                        value: 'incomeDate',
                        searchable: true,
                        type: 'date',
                        meta: 'from',
                        showArray: true,
                        disabled: false
                    },
                    {
                        text: 'Ημερομηνία εσόδου',
                        value: 'incomeDate',
                        searchable: true,
                        type: 'date',
                        meta: 'to',
                        showArray: false,
                        disabled: false
                    },
                    {
                        text: 'Τίτλος',
                        value: 'title',
                        searchable: true,
                        type: 'simple',
                        showArray: true,
                        disabled: false
                    },
                    {
                        text: 'Περιγραφή',
                        value: 'description',
                        searchable: true,
                        type: 'simple',
                        showArray: true,
                        disabled: false
                    },
                    {
                        text: 'Κατηγορία',
                        value: 'category',
                        subLevel: 'title',
                        level: 1,
                        type: 'api',
                        data: null,
                        searchable: true,
                        showArray: true,
                        disabled: false
                    },
                    {
                        text: 'Αριθμός τιμολογίου',
                        value: 'expenseInfo',
                        subLevel: 'invoiceNumber',
                        type: 'simple',
                        level: 1,
                        searchable: false,
                        showArray: true,
                        disabled: false
                    },
                    {
                        text: 'Ημερομηνία λήξης επιταγής',
                        value: 'expenseInfo',
                        subLevel: 'checkExpirationDate',
                        type: 'date',
                        level: 1,
                        searchable: false,
                        showArray: false,
                        disabled: false
                    },
                    {
                        text: 'Μέθοδος πληρωμής',
                        value: 'paymentMethod',
                        data: [
                            { displayValue: 'ΜΕΤΡΗΤΑ', value: 'CASH' },
                            { displayValue: 'ΕΠΙΤΑΓΗ', value: 'CHECK' },
                            { displayValue: 'ΤΡΑΠΕΖΑ', value: 'BANK' },
                            { displayValue: 'ΚΟΥΠΟΝΙΑ', value: 'COUPONS' }
                        ],
                        type: 'select',
                        searchable: true,
                        showArray: true,
                        disabled: false
                    },
                    {
                        text: 'Κατάσταση',
                        value: 'status',
                        data: [
                            { displayValue: 'ΕΚΚΡΕΜΕΙ', value: 'PENDING' },
                            { displayValue: 'ΠΛΗΡΩΜΕΝΟ', value: 'PAID' },
                            { displayValue: 'ΑΚΥΡΩΜΕΝΟ', value: 'CANCELED' }
                        ],
                        type: 'select',
                        searchable: true,
                        showArray: true,
                        disabled: false
                    },
                    {
                        text: 'Σύνολο (€)',
                        value: 'amount',
                        type: 'simple',
                        searchable: false,
                        showArray: true,
                        disabled: false
                    },
                    {
                        text: 'Μονάδα χρέωσης',
                        value: 'chargeUnit',
                        subLevel: 'title',
                        level: 1,
                        type: 'api',
                        data: null,
                        searchable: true,
                        showArray: true,
                        disabled: false
                    },
                    {
                        text: 'Καταχωρήθηκε από',
                        value: 'user',
                        subLevel: 'username',
                        searchable: true,
                        type: 'simple',
                        showArray: true,
                        disabled: false
                    },
                    {
                        text: 'Ημερομηνία Καταχώρησης',
                        value: 'createdAt',
                        searchable: true,
                        type: 'createdAtDate',
                        meta: 'from',
                        showArray: true,
                        disabled: false
                    },
                    {
                        text: 'Ημερομηνία Καταχώρησης',
                        value: 'createdAt',
                        searchable: true,
                        type: 'createdAtDate',
                        meta: 'to',
                        showArray: false,
                        disabled: false
                    }
                ],
                showImportDialog: false,
                size: 5,
                totalPages: 0,
                page: 1,
                panel: undefined,
                query: {},
                totals: { total: 0, totalAfterTaxes: 0, finalTotal: 0 },
                sort: null,
                pdf: false,
                excel: false
            }
        },
        watch: {
            panel() {
                if (this.panel === 0 && this.displayInfo[5].data === null && this.displayInfo[11].data === null) {
                    this.fetchAllCategories()
                    this.fetchAllChargeUnits()
                }
            },
            page() {
                var path = `/income?page=${this.page}&size=${this.size}`
                if (this.$route.fullPath !== path) {
                    this.$router.push(path)
                }
            },
            size() {
                var path = `/income?page=${this.page}&size=${this.size}`
                if (this.$route.fullPath !== path) {
                    this.$router.push(path)
                }
            }
        },
        created() {
            this.page = this.$route.query.page ? parseInt(this.$route.query.page) : this.page
            this.size = this.$route.query.size ? parseInt(this.$route.query.size) : this.size
            if (this.$store.getters.getFilters) {
                this.displayInfo = this.$store.getters.getFilters
            }
            if (this.$store.getters.getQuery) {
                this.query = this.$store.getters.getQuery
            }
            this.fetchAllIncomes()
            this.fetchIncomesTotals()
        },
        methods: {
            exportToCsv() {
                this.excel = true
                incomeService.getIncomesCsv(this.query).then((resp) => {
                    const data = 'text;charset=utf-8,' + encodeURIComponent(resp.data)
                    const link = document.createElement('a')
                    link.href = 'data:' + data
                    link.download = `export.csv`

                    const container = document.getElementById('export')
                    container.appendChild(link)
                    link.click()
                })
                this.excel = false
            },
            exportToPDF() {
                this.pdf = true
                html2pdf(document.getElementById('element-to-convert'),
                         {
                             hotfixes: 'px_scaling',
                             margin: 1,
                             filename: 'income.pdf',
                             image: { type: 'jpeg', quality: 1 },
                             html2canvas: { scale: 2 },
                             jsPDF: { unit: 'px', orientation: 'landscape', format: [1500, 1080], putOnlyUsedFonts: true }
                         }
                )
                this.pdf = false
            },
            filterResults(query, sort) {
                this.query = query
                this.sort = sort
                this.page = 1
                this.fetchAllIncomes()
                this.fetchIncomesTotals()
            },
            reloadFilters() {
                this.fetchAllCategories()
                this.fetchAllChargeUnits()
                this.query = {}
                this.sort = null
                this.totals = { total: 0, totalAfterTaxes: 0, finalTotal: 0 }
                this.fetchAllIncomes()
            },
            togglePanel() {
                const curr = this.panel
                this.panel = curr === undefined ? 0 : undefined
            },
            onDelete(income) {
                incomeService.deleteIncome(income.id).then(() => this.fetchAllIncomes())
            },
            paginationChange(page, size) {
                this.size = size
                this.page = page
                this.fetchAllIncomes()
            },
            handleClick(action, item) {
                this.$router.push(`/income/${item.id}/${action}?page=${this.page}&size=${this.size}`)
            },
            createIncome() {
                this.$router.push(`/income/create?page=${this.page}&size=${this.size}`)
            },
            fetchAllIncomes() {
                incomeService.getIncomes(this.page, this.size, this.query, this.sort).then(resp => {
                    this.incomes = resp.data.content
                    this.totalPages = resp.data.totalPages
                })
            },
            fetchAllCategories() {
                categoryService.getAllCategories().then(resp => {
                    this.displayInfo[5].data = resp.data
                })
            },
            fetchAllChargeUnits() {
                chargeUnitService.getAllChargeUnits().then(resp => {
                    this.displayInfo[11].data = resp.data
                })
            },
            fetchIncomesTotals() {
                incomeService.getTotals(this.query).then(resp => {
                    this.totals = resp.data
                })
            }
        }
    }
</script>

<style>
.v-expansion-panel-header__icon {
    display: none !important;
}
</style>

<style scoped>

.card-title {
    font-weight: 500;
    font-size: 1.25rem;
}
.v-l

.v-list-item {
    min-height: 30px !important;
}

.v-card {
    min-width: 250px;
    position: relative;
}

.edit-button:hover {
    background-color: whitesmoke;
    color: white;
}

.screen-card {
    padding: 4%;
}

.overflow-text {
    max-width: 79%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.pagination {
    justify-content: center;
}
</style>
